export default [
'Автоматика-Сервис',
'Газпром нефть',
'Газпромнефть-Автоматизация',
'Газпромнефть-Азия',
'Газпромнефть-АЭРО',
'Газпромнефть-Белнефтепродукт',
'Газпромнефть Бизнес-Сервис',
'Газпромнефть-Битумные материалы',
'Газпромнефть-Битумный терминал Юг',
'Газпромнефть-Восток',
'Газпромнефть Восточно-Европейские проекты',
'Газпромнефть-ГЕО',
'Газпромнефть-Дорожное строительство',
'Газпромнефть-Заполярье',
'Газпромнефть ИТО',
'Газпромнефть-Казахстан',
'Газпромнефть-Логистика',
'Газпромнефть Марин Бункер',
'Газпромнефть-МЗСМ',
'Газпромнефть-МНПЗ',
'Газпромнефть-Нефтесервис',
'Газпромнефть-Новосибирск',
'Газпромнефть-Ноябрьскнефтегаз',
'Газпромнефть-Ноябрьскнефтегазгеофизика',
'Газпромнефть НТЦ',
'Газпромнефть-ОЗСМ',
'Газпромнефть-ОНПЗ',
'Газпромнефть-Оренбург',
'Газпромнефть-Приразломная',
'Газпромнефть-Развитие',
'Газпромнефть-Региональные продажи',
'Газпромнефть-РЗБМ',
'Газпромнефть-Северо-Запад',
'Газпромнефть-Смазочные материалы',
'Газпромнефть-Снабжение',
'Газпромнефть-Таджикистан',
'Газпромнефть-Терминал',
'Газпромнефть-Терминал СПб',
'Газпромнефть-Технологические партнерства',
'Газпромнефть-Урал',
'Газпромнефть-Хантос',
'Газпромнефть-Центр',
'Газпромнефть-Цифровые решения',
'Газпром нефть шельф',
'Газпромнефть Шиппинг',
'Газпромнефть-Экспертные решения',
'Газпромнефть-Энергосервис',
'Газпромнефть-Ямал',
'Каталитические системы',
'Комплекс Парадная',
'Мегионгеология',
'Мегионское Управление Буровых Работ',
'Мегионэнергонефть',
'Мессояханефтегаз',
'Морнефтегазпроект',
'Нефтехимремонт',
'НОВА-Брит',
'Новороссийский нефтеперевалочный комплекс',
'Новоросснефтесервис',
'Ноябрьскэнергонефть',
'РМЗ «Газпромнефть-ОНПЗ»',
'Росполихим',
'Славнефть-Мегионнефтегаз',
'Славнефть-ЯНОС',
'Gazprom Middle East B.V.',
'Gazprom Neft Badra B.V.',
'Gazprom Neft Trading Gmbh',
'NIS'
];